import React from 'react';
import { useSiteSettings } from '../context/SettingsContext';
import { useAuth } from '../context/AuthContext';
import LandingGate, { isStaffOnlyHost } from './LandingGate';
import MaintenancePage from './MaintenancePage';

// Wraps a public page. Public pages should not be visible on staff-only domains
// (or if the site isn't published yet) unless the visitor is admin.
export default function PublicGate({ children, requireFlag }) {
  const { settings, loading } = useSiteSettings();
  const { user, loading: authLoading } = useAuth();

  if (loading || authLoading) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center">
        <div className="w-12 h-12 border-4 border-[#e11d2c] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  const host = typeof window !== 'undefined' ? window.location.hostname : '';
  const staffOnly = isStaffOnlyHost(settings?.staff_only_domains, host);
  const published = !!settings?.public_site_published;
  const sectionEnabled = !requireFlag || settings?.[requireFlag] !== false;
  const isAdmin = user?.role === 'admin';

  if (isAdmin) return children;

  // Signed-in customer on a staff-only host still gets the published storefront
  if (user && published && sectionEnabled) return children;

  // Staff-only domain (e.g. emergent URL) → show sign-in
  if (staffOnly) return <LandingGate />;

  // Site is un-published or this section is disabled → friendly maintenance page
  if (!published || !sectionEnabled) return <MaintenancePage />;

  return children;
}
